"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_debounce_1 = __importDefault(require("apollo-link-debounce"));
const debounceLink = new apollo_link_debounce_1.default(500);
exports.default = debounceLink;
//# sourceMappingURL=debounceLink.js.map